import { useInfiniteQuery } from "@tanstack/react-query";
import {
  albumsControllerAlbumsList,
  getAlbumsControllerAlbumsListQueryKey,
} from "@/lib/lutely-api/gen/albums/albums";
import type { AlbumsControllerAlbumsListParams } from "@/lib/lutely-api/gen/dtos";

type UseAlbumsInfiniteListParams = Omit<
  AlbumsControllerAlbumsListParams,
  "pageNumber"
>;

export function useAlbumsInfiniteList(
  params: UseAlbumsInfiniteListParams,
  options: {
    enabled?: boolean;
  } = {},
) {
  return useInfiniteQuery({
    queryKey: getAlbumsControllerAlbumsListQueryKey(params),
    queryFn: ({ pageParam }) =>
      albumsControllerAlbumsList({
        ...params,
        pageNumber: pageParam,
      }),
    getNextPageParam: (lastPage) => lastPage.nextPage,
    initialPageParam: 0,
    ...options,
  });
}
